import axios from '@/libs/api.request';

export const getNoticeList = data => {
    return axios.request({
        url: 'web/systemManagement/notice/getPageNoticeList',
        data: data,
        method: 'post'
    });
};

export const saveNotice = data => {
    return axios.request({
        url: 'api/systemManagement/notice/saveNotice',
        data: data,
        method: 'post'
    });
};

export const deleteNotice = data => {
    return axios.request({
        url: 'api/systemManagement/notice/deleteNotice',
        data: data,
        method: 'post'
    });
};